import _camelCase from 'lodash/camelCase';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  memosCount: {
    overdue: 0,
    open: 0,
  },
  overdue: null,
  open: null,
  closed: null,
  foundMemos: {
    count: null,
    items: [],
  },
  memoItemDetails: {},
  storeMemosCount: {
    openAmount: 0,
    overdueAmount: 0,
  },
  storeMemosItems: {},
  storeMemosFilters: {},
  selectedAssociateMemo: {},
};

const updateMemosData = ({ dataType, count, items, resetPagination }, state) => {
  const storeKey = _camelCase(dataType);
  const currentItems = state[storeKey]?.items || [];

  return {
    [storeKey]: {
      count,
      items: resetPagination ? items : [...currentItems, ...items],
    },
  };
};

export const memosReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.MEMOS_COUNT_LOADING:
    case actionTypes.MEMOS_ITEMS_LOADING:
    case actionTypes.MEMOS_SEARCH_LOADING:
    case actionTypes.MEMOS_ITEM_DETAILS_LOADING:
    case actionTypes.MEMOS_STORE_COUNT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.MEMOS_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        memosCount: payload,
      };
    case actionTypes.MEMOS_STORE_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        storeMemosCount: payload,
      };
    case actionTypes.MEMOS_COUNT_ERROR:
    case actionTypes.MEMOS_ITEMS_ERROR:
    case actionTypes.MEMOS_SEARCH_ERROR:
    case actionTypes.MEMOS_ITEM_DETAILS_ERROR:
    case actionTypes.MEMOS_STORE_COUNT_ERROR:
    case actionTypes.MEMOS_STORE_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.MEMOS_STORE_ITEMS_SUCCESS:
    case actionTypes.MEMOS_ITEMS_SUCCESS:
      return {
        ...state,
        ...updateMemosData(payload, state),
        loading: false,
      };
    case actionTypes.MEMOS_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundMemos: {
          count: payload.count,
          items: [...state.foundMemos.items, ...payload.items],
        },
      };
    case actionTypes.MEMOS_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        memoItemDetails: payload,
      };
    case actionTypes.MEMOS_SEARCH_CLEAR:
      return {
        ...state,
        loading: false,
        foundMemos: {
          ...INITIAL_STATE.foundMemos,
        },
      };
    case actionTypes.MEMOS_ITEMS_CLEAR:
      return {
        ...state,
        overdue: null,
        open: null,
        closed: null,
      };
    case actionTypes.MEMOS_ITEM_DETAILS_CLEAR:
      return {
        ...state,
        memoItemDetails: {},
      };
    case actionTypes.MEMOS_STORE_CLEAR:
      return {
        ...state,
        [payload]: {},
      };
    case actionTypes.SELECT_ASSOCIATE_MEMOS:
      return {
        ...state,
        selectedAssociateMemo: payload,
      };
    case actionTypes.MEMOS_STORE_FILTERS:
      return {
        ...state,
        storeMemosFilters: { ...state.storeMemosFilters, [payload.key]: payload.value },
      };
    case actionTypes.MEMOS_STORE_RESET_FILTERS:
      return {
        ...state,
        storeMemosFilters: {},
      };
    default:
      return state;
  }
};

export default memosReducer;
